import React from 'react';

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const DateOptionsArr = [
  {
    label: 'Monday',
    value: DayOfWeek.MONDAY,
  },
  {
    label: 'Tuesday',
    value: DayOfWeek.TUESDAY,
  },
  {
    label: 'Wednesday',
    value: DayOfWeek.WEDNESDAY,
  },
  {
    label: 'Thursday',
    value: DayOfWeek.THURSDAY,
  },
  {
    label: 'Friday',
    value: DayOfWeek.FRIDAY,
  },
  {
    label: 'Saturday',
    value: DayOfWeek.SATURDAY,
  },
  {
    label: 'Sunday',
    value: DayOfWeek.SUNDAY,
  },
];

export const DateOptions = DateOptionsArr.map(({label, value}) => (
  <option key={value} value={value}>
    {label}
  </option>
));
